(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cplayer-umd", [], factory);
	else if(typeof exports === 'object')
		exports["cplayer-umd"] = factory();
	else
		root["cplayer-umd"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var shallowEqual_1 = __webpack_require__(10);
function baseRemoveMusic(item, playlist, nowpoint, newpoint) {
    var targetPoint = void 0;
    var needupdate = false;
    playlist.forEach(function (a, index) {
        if (shallowEqual_1.default(a, item)) {
            targetPoint = index;
        }
    });
    if (typeof targetPoint !== 'undefined') {
        playlist.splice(targetPoint, 1);
        if (nowpoint > targetPoint) {
            nowpoint--;
            needupdate = false;
        } else if (nowpoint === targetPoint) {
            nowpoint = newpoint(nowpoint);
            needupdate = true;
        }
    }
    return { playlist: playlist, nowpoint: nowpoint, needupdate: needupdate };
}
exports.baseRemoveMusic = baseRemoveMusic;

var listloopPlaymode = function () {
    function listloopPlaymode() {
        var playlist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var point = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        _classCallCheck(this, listloopPlaymode);

        this.__playlist = [];
        this.point = 0;
        this.__playlist = playlist;
        this.to(point);
    }

    _createClass(listloopPlaymode, [{
        key: "next",
        value: function next() {
            this.point = this.nextPoint();
            return this.playlist[this.point];
        }
    }, {
        key: "prev",
        value: function prev() {
            this.point = this.prevPoint();
            return this.playlist[this.point];
        }
    }, {
        key: "now",
        value: function now() {
            return this.playlist[this.point];
        }
    }, {
        key: "nowpoint",
        value: function nowpoint() {
            return this.point;
        }
    }, {
        key: "to",
        value: function to(point) {
            this.point = Math.max(0, Math.min(point, this.__playlist.length - 1));
        }
    }, {
        key: "addMusic",
        value: function addMusic(item) {
            this.__playlist.push(item);
        }
    }, {
        key: "nextPoint",
        value: function nextPoint() {
            var res = this.point + 1;
            if (res >= this.__playlist.length) {
                res = 0;
            }
            return res;
        }
    }, {
        key: "prevPoint",
        value: function prevPoint() {
            var res = this.point - 1;
            if (res < 0) {
                res = this.__playlist.length - 1;
            }
            return res;
        }
    }, {
        key: "removeMusic",
        value: function removeMusic(item) {
            var _this = this;

            var _baseRemoveMusic = baseRemoveMusic(item, this.__playlist, this.point, function (point) {
                return Math.max(0, Math.min(point, _this.__playlist.length - 1));
            }),
                playlist = _baseRemoveMusic.playlist,
                nowpoint = _baseRemoveMusic.nowpoint,
                needupdate = _baseRemoveMusic.needupdate;

            this.__playlist = playlist;
            this.point = nowpoint;
            return needupdate;
        }
    }, {
        key: "playlist",
        get: function get() {
            return this.__playlist;
        }
    }]);

    return listloopPlaymode;
}();

exports.listloopPlaymode = listloopPlaymode;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAiACIDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAcDBAUG/8QALhAAAgEDAwIFAwMFAAAAAAAAAQIDAAQRBRIhE0EGIjFRkRQzYTI1cXOBocHR/8QAGAEAAwEBAAAAAAAAAAAAAAAAAQIDBAX/xAAiEQACAQMCBwAAAAAAAAAAAAAAAQIDETESFAQhIkFRYWL/2gAMAwEAAhEDEQA/AGBo7mOKMEBjgc4rqLaRWXG1fgUttA1qNbnpPdGV5mIRRhkiKgeTjkE5J5/1W9pniH6jVbuPdiO2gJwHG13B5wcc44+a5tPpNM4N3OwlC45RfgVlXMA2t5E/nFVZ/EEaWVlcmJmjuDHnDAdIP6MR3GSBx71Fe37LbSSKylVIyNwyM002IotGc2N7cr6+1FYTXu5iepKcnP66KzF9AoBfQ2LmzgWWJp3L72A8rNt2kY5x/wBrtfD+oSXkQ6k8iQSRuJVjwr78DcATx6YyfYehNcbsttTkayGoiGcPuh3REo2FG0bt2R6e3fvVW2vulYSSMPND9vk46jcA/Ab/ABXTlBSXsCnpvfAydb8TR3eg7bMrGrStB1c8r0wTsP4PDKe/OeRUXiPxFLBojump6fFcTtGFeCTDHaoJyMe5A70uYte+n097Z7eK6EjA4mJCptXAK7SOcE1S1a9jvbqNoYzFCkSIiFtxGBzk9znvQXD81cV1kkMSAWDQRt9bMuVB272OOPTOKKVu4+5+aKO2+gbleC5bfusf9U1ctlB1RYiAYy/Kn0P9qKKtLIkMGfeKBdkAADjgVFcffYdgcD8UUU6JPuR0UUURT//Z"

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(9);
var listloop_1 = __webpack_require__(0);
var events_1 = __webpack_require__(2);
var lyric_1 = __webpack_require__(11);
var singlecycle_1 = __webpack_require__(12);
var listrandom_1 = __webpack_require__(13);
var mediaSession_1 = __webpack_require__(14);
var cplayerView = undefined;
if (true) {
    cplayerView = __webpack_require__(15).default;
}
var defaultOption = {
    playlist: [],
    point: 0,
    volume: 1,
    playmode: 'listloop',
    autoplay: false
};
var playmodes = {
    listloop: listloop_1.listloopPlaymode,
    singlecycle: singlecycle_1.singlecyclePlaymode,
    listrandom: listrandom_1.listrandomPlaymode
};
function playlistPreFilter(playlist) {
    return playlist.map(function (audio, index) {
        var res = Object.assign({}, audio);
        if (typeof audio.lyric === 'string' && audio.lyric.replace(/\n+/gi, "\n").trim()) {
            res.lyric = lyric_1.decodeLyricStr(audio.lyric);
        }
        if (typeof audio.sublyric === 'string' && audio.sublyric.replace(/\n+/gi, "\n").trim()) {
            res.sublyric = lyric_1.decodeLyricStr(audio.sublyric);
        }
        return res;
    });
}

var cplayer = function (_events_1$EventEmitte) {
    _inherits(cplayer, _events_1$EventEmitte);

    function cplayer(options) {
        _classCallCheck(this, cplayer);

        var _this = _possibleConstructorReturn(this, (cplayer.__proto__ || Object.getPrototypeOf(cplayer)).call(this));

        _this.__paused = true;
        _this.playmodeName = 'listloop';
        _this._volume = 0;
        _this.eventHandlers = {
            handlePlay: function handlePlay() {
                if (_this.__paused) {
                    _this.pause();
                }
            },
            handlePlaying: function handlePlaying() {
                if (_this.audioElement.currentTime === 0) {
                    _this.emit('started');
                }
            },
            handleTimeUpdate: function handleTimeUpdate() {
                var time = _this.audioElement.duration;
                var playedTime = _this.audioElement.currentTime;
                _this.emit('timeupdate', playedTime, time);
            },
            handleCanPlayThrough: function handleCanPlayThrough() {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                _this.emit.apply(_this, ['canplaythrough'].concat(args));
            },
            handlePause: function handlePause() {
                if (!_this.__paused && !_this.audioElement.ended) {
                    _this.play(true).catch(function (e) {
                        console.log(e);
                        _this.pause();
                    });
                }
            },
            handleEnded: function handleEnded() {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                _this.emit.apply(_this, ['ended'].concat(args));
                if (!_this.__paused) {
                    _this.next();
                }
            },
            handlePlayListChange: function handlePlayListChange() {
                for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = arguments[_key3];
                }

                _this.emit.apply(_this, ['playlistchange'].concat(args));
            },
            handlePlaymodeChange: function handlePlaymodeChange() {
                var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.mode;

                _this.emit('playmodechange', mode);
            },
            handleLoadeddata: function handleLoadeddata() {
                var time = _this.audioElement.duration;
                var playedTime = _this.audioElement.currentTime;
                _this.emit('timeupdate', playedTime, time);
            }
        };
        options = Object.assign({}, defaultOption, options);
        _this.playmode = new playmodes[options.playmode](playlistPreFilter(options.playlist), options.point);
        if (true) _this.view = new cplayerView(_this, options);
        mediaSession_1.cplayerMediaSessionPlugin(_this);
        // 同步调用会导致，用户的事件得不到触发
        setImmediate(function () {
            _this.openAudio();
            _this.setVolume(options.volume);
            if (options.autoplay && _this.playlist.length > 0) {
                _this.play(true).catch(function (e) {
                    console.log(e);
                    _this.pause();
                });
            }
        });
        return _this;
    }

    _createClass(cplayer, [{
        key: "initializeEventEmitter",
        value: function initializeEventEmitter(element) {
            var a = element.addEventListener.bind(element);
            var e = this.eventHandlers;
            a('timeupdate', e.handleTimeUpdate);
            a('canplaythrough', e.handleCanPlayThrough);
            a('pause', e.handlePause);
            a('play', e.handlePlay);
            a('playing', e.handlePlaying);
            a('ended', e.handleEnded);
            a('loadeddata', e.handleLoadeddata);
        }
    }, {
        key: "removeEventEmitter",
        value: function removeEventEmitter(element) {
            var r = element.removeEventListener.bind(element);
            var e = this.eventHandlers;
            r('timeupdate', e.handleTimeUpdate);
            r('canplaythrough', e.handleCanPlayThrough);
            r('pause', e.handlePause);
            r('play', e.handlePlay);
            r('playing', e.handlePlaying);
            r('ended', e.handleEnded);
            r('loadeddata', e.handleLoadeddata);
        }
    }, {
        key: "setCurrentTime",
        value: function setCurrentTime(currentTime) {
            if (typeof currentTime === 'string') {
                currentTime.trim();
                if (currentTime[currentTime.length - 1] === '%') {
                    var percentage = parseFloat(currentTime);
                    currentTime = this.duration * (percentage / 100);
                }
            }
            if (this.audioElement) {
                this.audioElement.currentTime = parseFloat(currentTime.toString());
            }
        }
    }, {
        key: "isPlaying",
        value: function isPlaying() {
            return this.audioElement.currentTime > 0 && !this.audioElement.paused && !this.audioElement.ended && this.audioElement.readyState > 2;
        }
    }, {
        key: "openAudio",
        value: function openAudio() {
            var audio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.nowplay;

            if (audio) {
                if (audio.type === 'video') {
                    if (!(this.audioElementType === 'HTMLVideoElement')) {
                        if (typeof this.audioElement !== 'undefined') {
                            this.removeEventEmitter(this.audioElement);
                            this.audioElement.src = '';
                        }
                        this.audioElement = document.createElement('video');
                        if (this.audioElement instanceof HTMLVideoElement) {
                            this.audioElementType = 'HTMLVideoElement';
                            this.audioElement.loop = false;
                            this.audioElement.autoplay = false;
                            this.audioElement.poster = audio.poster;
                            this.audioElement.setAttribute('playsinline', 'true');
                            this.audioElement.setAttribute('webkit-playsinline', 'true');
                        }
                        this.initializeEventEmitter(this.audioElement);
                        this.emit('audioelementchange', this.audioElement);
                    }
                } else {
                    if (!(this.audioElementType === 'HTMLAudioElement')) {
                        if (typeof this.audioElement !== 'undefined') {
                            this.removeEventEmitter(this.audioElement);
                            this.audioElement.src = '';
                        }
                        this.audioElement = new Audio();
                        this.audioElementType = 'HTMLAudioElement';
                        this.audioElement.loop = false;
                        this.audioElement.autoplay = false;
                        this.initializeEventEmitter(this.audioElement);
                        this.emit('audioelementchange', this.audioElement);
                    }
                }
                this.setVolume(this.volume);
                this.audioElement.src = this.nowplay.src;
                this.emit('openaudio', audio);
                if (!this.__paused) {
                    this.play();
                }
            }
        }
    }, {
        key: "toggleMode",
        value: function toggleMode() {
            switch (this.playmodeName) {
                case 'listloop':
                    this.setMode('singlecycle');
                    break;
                case 'singlecycle':
                    this.setMode('listrandom');
                    break;
                case 'listrandom':
                    this.setMode('listloop');
                    break;
            }
        }
    }, {
        key: "setMode",
        value: function setMode(playmode) {
            if (typeof playmode === 'string') {
                if (this.playmodeName !== playmode) {
                    if (playmodes[playmode]) {
                        this.playmode = new playmodes[playmode](this.playlist, this.nowplaypoint);
                        this.playmodeName = playmode;
                        this.eventHandlers.handlePlaymodeChange();
                    }
                }
            }
        }
    }, {
        key: "getMode",
        value: function getMode() {
            return this.mode;
        }
    }, {
        key: "play",
        value: function play() {
            var Forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var isPlaying = this.isPlaying();
            var res = void 0;
            if (!isPlaying && this.playlist.length > 0 || Forced) {
                res = this.audioElement.play();
            }
            if (this.__paused) {
                this.__paused = false;
                this.emit('playstatechange', this.__paused);
                this.emit('play');
            }
            return res;
        }
    }, {
        key: "pause",
        value: function pause() {
            var Forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var isPlaying = this.isPlaying();
            if (isPlaying && this.playlist.length > 0 || Forced) {
                this.audioElement.pause();
            }
            if (!this.__paused) {
                this.__paused = true;
                this.emit('playstatechange', this.__paused);
                this.emit('pause');
            }
        }
    }, {
        key: "to",
        value: function to(id) {
            this.playmode.to(id);
            this.openAudio();
        }
    }, {
        key: "next",
        value: function next() {
            this.playmode.next();
            this.openAudio();
        }
    }, {
        key: "prev",
        value: function prev() {
            this.playmode.prev();
            this.openAudio();
        }
    }, {
        key: "togglePlayState",
        value: function togglePlayState() {
            if (this.__paused) {
                this.play();
            } else {
                this.pause();
            }
        }
    }, {
        key: "add",
        value: function add(item) {
            item = playlistPreFilter([item])[0];
            this.playmode.addMusic(item);
            this.eventHandlers.handlePlayListChange();
            if (this.playlist.length === 1) {
                this.to(0);
            }
        }
    }, {
        key: "remove",
        value: function remove(item) {
            var needUpdate = this.playmode.removeMusic(item);
            this.eventHandlers.handlePlayListChange();
            if (needUpdate) {
                this.openAudio();
            }
        }
    }, {
        key: "setVolume",
        value: function setVolume(volume) {
            this._volume = parseFloat(volume);
            if (this.audioElement) this.audioElement.volume = Math.max(0.0, Math.min(1.0, this._volume));
            this.emit('volumechange', this.audioElement.volume);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            var _this2 = this;

            if (this.audioElement) {
                this.audioElement.src = null;
                this.audioElement.removeEventListener("timeupdate", this.eventHandlers.handleTimeUpdate);
                this.removeAllListeners();
            }
            if (this.view) this.view.destroy();
            Object.getOwnPropertyNames(this).forEach(function (name) {
                return delete _this2[name];
            });
            this.__proto__ = Object;
        }
    }, {
        key: "mode",
        set: function set(playmode) {
            this.setMode(playmode);
        },
        get: function get() {
            return this.playmodeName;
        }
    }, {
        key: "volume",
        set: function set(volume) {
            this.setVolume(volume);
        },
        get: function get() {
            return this._volume;
        }
    }, {
        key: "playlist",
        get: function get() {
            return this.playmode.playlist;
        }
    }, {
        key: "nowplay",
        get: function get() {
            return this.playmode && this.playmode.now();
        }
    }, {
        key: "nowplaypoint",
        get: function get() {
            return this.playmode && this.playmode.nowpoint();
        }
    }, {
        key: "played",
        get: function get() {
            return !this.__paused;
        }
    }, {
        key: "paused",
        get: function get() {
            return this.__paused;
        }
    }, {
        key: "duration",
        get: function get() {
            if (this.audioElement) {
                return this.audioElement.duration;
            }
            return 0;
        }
    }, {
        key: "currentTime",
        get: function get() {
            if (this.audioElement) {
                return this.audioElement.currentTime;
            }
            return 0;
        }
    }]);

    return cplayer;
}(events_1.EventEmitter);

exports.default = cplayer;
if (true) {
    var parseCPlayerTag = function parseCPlayerTag() {
        Array.prototype.forEach.call(document.querySelectorAll('template[cplayer]'), function (element) {
            element.attributes.getNamedItem('loaded') || new cplayer(Object.assign({ generateBeforeElement: true, deleteElementAfterGenerate: true, element: element }, JSON.parse(element.innerHTML)));
        });
    };

    window.addEventListener("load", parseCPlayerTag);
}
window.cplayer = cplayer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(6);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(8)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) {
            // .length of function is 2
            'use strict';

            if (target == null) {
                // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) {
                    // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: true });
var hasOwn = Object.prototype.hasOwnProperty;
function is(x, y) {
    if (x == y) {
        return x != 0 || y != 0 || 1 / x == 1 / y;
    } else {
        return x != x && y != y;
    }
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== 'object' || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== 'object' || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}
exports.default = shallowEqual;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Lyric = function () {
    function Lyric(items, raw) {
        _classCallCheck(this, Lyric);

        this.items = [];
        this.items = items;
        this.raw = raw;
    }

    _createClass(Lyric, [{
        key: "getLyric",
        value: function getLyric(time) {
            return this.items.reduce(function (p, c) {
                if (c.time < time && (!p || p.time < c.time)) {
                    return c;
                }
                return p;
            }, undefined);
        }
    }, {
        key: "getNextLyric",
        value: function getNextLyric(time) {
            return this.items.reduce(function (p, c) {
                if (c.time > time && (!p || p.time > c.time)) {
                    return c;
                }
                return p;
            }, undefined);
        }
    }, {
        key: "toString",
        value: function toString() {
            return this.raw;
        }
    }]);

    return Lyric;
}();

exports.Lyric = Lyric;
function decodeLyricStr(lyricStr, options) {
    if (typeof lyricStr !== 'string') return lyricStr;
    var lyric = [];
    lyricStr.replace(/\n+/gi, "\n").trim().split("\n").forEach(function (lyricStrItem) {
        lyric.push.apply(lyric, _toConsumableArray(decodeLyricStrItem(lyricStrItem)));
    });
    if (lyric.length == 0) return undefined;
    return new Lyric(lyric, lyricStr);
}
exports.decodeLyricStr = decodeLyricStr;
function decodeLyricStrItem(lyricItemStr) {
    var res = [];
    var timestr = lyricItemStr.match(/\[\d+\:[\.\d]+\]/gi);
    var word = /(?:\[\d+\:[\.\d]+\])*(.*)/gi.exec(lyricItemStr)[1].trim();
    if (timestr && word) {
        timestr.forEach(function (timestr) {
            var z = /\[(\d+)\:([\.\d]+)\]/gi.exec(timestr.trim());
            var time = parseInt(z[1]) * 60 * 1000 + parseFloat(z[2]) * 1000;
            res.push({
                time: time,
                word: word
            });
        });
    }
    return res;
}
exports.decodeLyricStrItem = decodeLyricStrItem;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var listloop_1 = __webpack_require__(0);

var singlecyclePlaymode = function () {
    function singlecyclePlaymode() {
        var playlist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var point = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        _classCallCheck(this, singlecyclePlaymode);

        this.__playlist = [];
        this.__playlist = playlist;
        this.to(point);
    }

    _createClass(singlecyclePlaymode, [{
        key: "next",
        value: function next() {
            return this.__playlist[this.point];
        }
    }, {
        key: "prev",
        value: function prev() {
            return this.__playlist[this.point];
        }
    }, {
        key: "now",
        value: function now() {
            return this.__playlist[this.point];
        }
    }, {
        key: "nowpoint",
        value: function nowpoint() {
            return this.point;
        }
    }, {
        key: "to",
        value: function to(point) {
            this.point = Math.max(0, Math.min(point, this.__playlist.length - 1));
        }
    }, {
        key: "addMusic",
        value: function addMusic(item) {
            this.__playlist.push(item);
        }
    }, {
        key: "removeMusic",
        value: function removeMusic(item) {
            var _this = this;

            var _listloop_1$baseRemov = listloop_1.baseRemoveMusic(item, this.__playlist, this.point, function (point) {
                return Math.max(0, Math.min(point, _this.__playlist.length - 1));
            }),
                playlist = _listloop_1$baseRemov.playlist,
                nowpoint = _listloop_1$baseRemov.nowpoint,
                needupdate = _listloop_1$baseRemov.needupdate;

            this.__playlist = playlist;
            this.point = nowpoint;
            return needupdate;
        }
    }, {
        key: "playlist",
        get: function get() {
            return this.__playlist;
        }
    }]);

    return singlecyclePlaymode;
}();

exports.singlecyclePlaymode = singlecyclePlaymode;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var listloop_1 = __webpack_require__(0);

var listrandomPlaymode = function () {
    function listrandomPlaymode() {
        var playlist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var point = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        _classCallCheck(this, listrandomPlaymode);

        this.__playlist = [];
        this.point = 0;
        this.__playlist = playlist;
        this.to(point);
    }

    _createClass(listrandomPlaymode, [{
        key: "next",
        value: function next() {
            this.point = this.randomPoint();
            return this.__playlist[this.point];
        }
    }, {
        key: "prev",
        value: function prev() {
            this.point = this.randomPoint();
            return this.__playlist[this.point];
        }
    }, {
        key: "now",
        value: function now() {
            return this.__playlist[this.point];
        }
    }, {
        key: "nowpoint",
        value: function nowpoint() {
            return this.point;
        }
    }, {
        key: "to",
        value: function to(point) {
            this.point = Math.max(0, Math.min(point, this.__playlist.length - 1));
        }
    }, {
        key: "addMusic",
        value: function addMusic(item) {
            this.__playlist.push(item);
        }
    }, {
        key: "randomPoint",
        value: function randomPoint() {
            if (this.__playlist.length > 1) {
                var random = Math.floor(this.__playlist.length * Math.random());
                if (random === this.point) {
                    return this.randomPoint();
                } else {
                    return random;
                }
            } else return 0;
        }
    }, {
        key: "removeMusic",
        value: function removeMusic(item) {
            var _this = this;

            var _listloop_1$baseRemov = listloop_1.baseRemoveMusic(item, this.__playlist, this.point, function (point) {
                return _this.randomPoint();
            }),
                playlist = _listloop_1$baseRemov.playlist,
                nowpoint = _listloop_1$baseRemov.nowpoint,
                needupdate = _listloop_1$baseRemov.needupdate;

            this.__playlist = playlist;
            this.point = nowpoint;
            return needupdate;
        }
    }, {
        key: "playlist",
        get: function get() {
            return this.__playlist;
        }
    }]);

    return listrandomPlaymode;
}();

exports.listrandomPlaymode = listrandomPlaymode;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var defaultPoster = __webpack_require__(1);
function cplayerMediaSessionPlugin(player) {
    if ('mediaSession' in navigator) {
        navigator.mediaSession.metadata = mediaMetadata(player.nowplay);
        navigator.mediaSession.setActionHandler('play', function () {
            return player.play();
        });
        navigator.mediaSession.setActionHandler('pause', function () {
            return player.pause();
        });
        navigator.mediaSession.setActionHandler('previoustrack', function () {
            return player.prev();
        });
        navigator.mediaSession.setActionHandler('nexttrack', function () {
            return player.next();
        });
        player.on('openaudio', function () {
            navigator.mediaSession.metadata = mediaMetadata(player.nowplay);
        });
    }
}
exports.cplayerMediaSessionPlugin = cplayerMediaSessionPlugin;
function mediaMetadata(audio) {
    return new MediaMetadata({
        title: audio.name,
        artist: audio.artist,
        album: audio.album,
        artwork: [{ src: audio.poster || defaultPoster }]
    });
}
exports.mediaMetadata = mediaMetadata;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var returntypeof_1 = __webpack_require__(16);
var events_1 = __webpack_require__(2);
var defaultPoster = __webpack_require__(1);
var htmlTemplate = __webpack_require__(17);
var playIcon = __webpack_require__(18);
var style = __webpack_require__(19);
function kanaFilter(str) {
    var starttag = '<span class="cp-lyric-text-zoomout">';
    var endtag = '</span>';
    var res = '';
    var startflag = false;
    for (var i = 0; i < str.length; i++) {
        var ch = str.charAt(i);
        var kano = /[ぁ-んァ-ン]/.test(ch);
        if (kano && !startflag) {
            res += starttag;
            startflag = true;
        }
        if (!kano && startflag) {
            res += endtag;
            startflag = false;
        }
        res += ch;
    }
    if (startflag) {
        res += endtag;
    }
    return res;
}
function buildLyric(lyric, sublyric) {
    var zoomOutKana = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return (zoomOutKana ? kanaFilter(lyric) : lyric) + (sublyric ? "<span class=\"cp-lyric-text-sub\">" + sublyric + "</span>" : '');
}
function secondNumber2TimeStr(secondTime) {
    var minute = parseInt((secondTime / 60).toString()).toString().padStart(2, '0');
    var second = parseInt((secondTime % 60).toString()).toString().padStart(2, '0');
    return minute + ':' + second;
}
var defaultOption = {
    element: document.body,
    generateBeforeElement: false,
    deleteElementAfterGenerate: false,
    zoomOutKana: false,
    showPlaylist: false,
    showPlaylistButton: true,
    dropDownMenuMode: 'bottom',
    width: '',
    size: '12px',
    style: ''
};
function createStyleElement(style) {
    var styleElement = document.createElement('style');
    styleElement.id = 'cplayer-style';
    styleElement.innerHTML = style;
    return styleElement;
}
function createShadowElement(targetElement, htmlTemplate, style) {
    var shadowRoot = targetElement.createShadowRoot();
    shadowRoot.innerHTML = htmlTemplate;
    shadowRoot.appendChild(createStyleElement(style));
    return shadowRoot.firstChild;
}
function createBeforeElement(targetElement, htmlTemplate, style) {
    var element = document.createElement('div');
    element.innerHTML = htmlTemplate;
    targetElement.parentNode.insertBefore(element, targetElement);
    if (!document.getElementById('cplayer-style')) {
        document.body.appendChild(createStyleElement(style));
    }
    return element.firstChild;
}
function createBeforeShadowElement(targetElement, htmlTemplate, style) {
    var element = document.createElement('div');
    var shadowRoot = element.createShadowRoot();
    shadowRoot.innerHTML = htmlTemplate;
    shadowRoot.appendChild(createStyleElement(style));
    targetElement.parentNode.insertBefore(element, targetElement);
    return shadowRoot.firstChild;
}
function createElement(targetElement, htmlTemplate, style) {
    targetElement.innerHTML = htmlTemplate;
    if (!document.getElementById('cplayer-style')) {
        document.body.appendChild(createStyleElement(style));
    }
    return targetElement.firstChild;
}

var cplayerView = function (_events_1$EventEmitte) {
    _inherits(cplayerView, _events_1$EventEmitte);

    function cplayerView(player, options) {
        _classCallCheck(this, cplayerView);

        var _this = _possibleConstructorReturn(this, (cplayerView.__proto__ || Object.getPrototypeOf(cplayerView)).call(this));

        _this.elementLinks = returntypeof_1.default(_this.getElementLinks);
        _this.dropDownMenuShowInfo = true;
        _this.__OldVolume = 1;
        _this.__OldLyric = '';
        _this.__OldTotalTime = 0;
        _this.handlePlaylistchange = function () {
            _this.updatePlaylist();
        };
        _this.handleClickListButton = function () {
            _this.toggleDropDownMenu();
        };
        _this.handleClickModeButton = function () {
            _this.player.toggleMode();
        };
        _this.handleClickPlayList = function (point, event) {
            if (_this.player.nowplaypoint !== point) {
                _this.player.to(point);
                _this.player.play();
            }
        };
        _this.handleClickPlayButton = function () {
            _this.player.togglePlayState();
        };
        _this.handleClickVolumeButton = function () {
            _this.toggleVolumeControllerKeepShow();
        };
        _this.handleOpenAudio = function (audio) {
            if (audio.type !== 'video') {
                _this.setPoster(audio.poster || defaultPoster);
            } else {
                _this.setPoster('none');
            }
            _this.setProgress(0, 0, 0);
            _this.elementLinks.title.innerText = audio.name;
            _this.elementLinks.artist.innerText = audio.artist || '';
            _this.updateLyric();
            _this.updatePlaylist();
        };
        _this.handleModeChange = function (mode) {
            _this.setMode(mode);
        };
        _this.handleVolumeChange = function (volume) {
            _this.setVolume(volume);
        };
        _this.handleTimeUpdate = function (playedTime, time) {
            _this.setProgress(playedTime / time, playedTime, time);
            _this.updateLyric(playedTime);
        };
        _this.handleClickPrevButton = function () {
            _this.player.prev();
            _this.player.play();
        };
        _this.handleClickNextButton = function () {
            _this.player.next();
            _this.player.play();
        };
        _this.handlePlayStateChange = function (paused) {
            _this.setPlayIcon(paused);
        };
        _this.handleMouseVolumeController = function (event) {
            _this.removeVolumeControllerKeepShow();
            if (event.buttons === 1 || typeof event.buttons === 'undefined' && event.which === 1) {
                var volume = Math.max(0, Math.min(1.0, (event.clientX - _this.elementLinks.volumeController.getBoundingClientRect().left) / _this.elementLinks.volumeController.clientWidth));
                _this.player.setVolume(volume);
                _this.setVolume(volume);
            }
        };
        _this.handleTouchVolumeController = function (event) {
            _this.removeVolumeControllerKeepShow();
            var volume = Math.max(0, Math.min(1.0, (event.targetTouches[0].clientX - _this.elementLinks.volumeController.getBoundingClientRect().left) / _this.elementLinks.volumeController.clientWidth));
            _this.player.setVolume(volume);
            _this.setVolume(volume);
        };
        _this.handleAudioElementChange = function (element) {
            if (element instanceof HTMLVideoElement) {
                _this.elementLinks.poster.appendChild(element);
            } else {
                _this.elementLinks.poster.innerHTML = '';
            }
        };
        _this.handleMouseProgress = function (event) {
            if (event.buttons === 1 || typeof event.buttons === 'undefined' && event.which === 1) {
                var progress = Math.max(0, Math.min(1.0, (event.clientX - _this.elementLinks.progress.getBoundingClientRect().left) / _this.elementLinks.progress.clientWidth));
                _this.player.setCurrentTime(progress * 100 + '%');
            }
        };
        _this.handleTouchProgress = function (event) {
            var progress = Math.max(0, Math.min(1.0, (event.targetTouches[0].clientX - _this.elementLinks.progress.getBoundingClientRect().left) / _this.elementLinks.progress.clientWidth));
            _this.player.setCurrentTime(progress * 100 + '%');
        };
        _this.options = Object.assign({}, defaultOption, options);
        _this.player = player;
        if (_this.options.generateBeforeElement) {
            if (_this.options.element.createShadowRoot) {
                _this.rootElement = createBeforeShadowElement(_this.options.element, htmlTemplate, style + _this.options.style);
            } else {
                _this.rootElement = createBeforeElement(_this.options.element, htmlTemplate, style + _this.options.style);
            }
        } else {
            if (_this.options.element.createShadowRoot) {
                _this.rootElement = createShadowElement(_this.options.element, htmlTemplate, style + _this.options.style);
            } else {
                _this.rootElement = createElement(_this.options.element, htmlTemplate, style + _this.options.style);
            }
        }
        if (options.deleteElementAfterGenerate) {
            options.element.parentElement.removeChild(options.element);
        }
        _this.rootElement.style.width = _this.options.width;
        _this.rootElement.style.fontSize = _this.options.size;
        _this.elementLinks = _this.getElementLinks();
        _this.injectEventListener();
        _this.setPlayIcon(_this.player.paused);
        _this.dropDownMenuShowInfo = !_this.options.showPlaylist;
        if (_this.dropDownMenuShowInfo) {
            _this.showInfo();
        } else _this.showPlaylist();
        if (!_this.options.showPlaylistButton) _this.elementLinks.button.list.style.display = 'none';else _this.elementLinks.button.list.style.display = '';
        _this.elementLinks.dropDownMenu.classList.add('cp-drop-down-menu-' + _this.options.dropDownMenuMode);
        if (_this.options.dark) {
            _this.dark();
        }
        if (_this.options.big) {
            _this.big();
        }
        _this.setPoster(_this.player.nowplay.poster || defaultPoster);
        _this.setProgress(_this.player.currentTime / _this.player.duration, _this.player.currentTime, _this.player.duration);
        _this.elementLinks.title.innerText = _this.player.nowplay.name;
        _this.elementLinks.artist.innerText = _this.player.nowplay.artist || '';
        _this.updateLyric();
        _this.updatePlaylist();
        return _this;
    }

    _createClass(cplayerView, [{
        key: "getRootElement",
        value: function getRootElement() {
            return this.rootElement;
        }
    }, {
        key: "dark",
        value: function dark() {
            this.rootElement.classList.add('cp-dark');
        }
    }, {
        key: "big",
        value: function big() {
            this.rootElement.classList.add('cp-big');
        }
    }, {
        key: "getPlayListLinks",
        value: function getPlayListLinks() {
            var rootElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rootElement;

            return rootElement.querySelectorAll('.cp-playlist li');
        }
    }, {
        key: "getElementLinks",
        value: function getElementLinks() {
            var rootElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rootElement;

            var gebc = function gebc(className) {
                return rootElement.getElementsByClassName(className)[0];
            };
            return {
                icon: {
                    play: gebc('cp-play-icon'),
                    mode: gebc('cp-mode-icon')
                },
                button: {
                    prev: gebc('cp-prev-button'),
                    play: gebc('cp-play-button'),
                    next: gebc('cp-next-button'),
                    volume: gebc('cp-volume-icon'),
                    list: gebc('cp-list-button'),
                    mode: gebc('cp-mode-button')
                },
                progress: gebc('cp-progress'),
                progressFill: gebc('cp-progress-fill'),
                progressButton: gebc('cp-progress-button'),
                progressDuration: gebc('cp-progress-duration'),
                progressCurrentTime: gebc('cp-progress-current-time'),
                poster: gebc('cp-poster'),
                title: gebc('cp-audio-title'),
                artist: gebc('cp-audio-artist'),
                lyric: gebc('cp-lyric-text'),
                lyricContainer: gebc('cp-lyric'),
                volumeController: gebc('cp-volume-controller'),
                volumeFill: gebc('cp-volume-fill'),
                volumeControllerButton: gebc('cp-volume-controller-button'),
                volumeControllerContainer: gebc('cp-volume-container'),
                dropDownMenu: gebc('cp-drop-down-menu'),
                playlist: gebc('cp-playlist'),
                playlistItems: this.getPlayListLinks(rootElement)
            };
        }
    }, {
        key: "setPlayIcon",
        value: function setPlayIcon(paused) {
            if (paused) {
                this.elementLinks.icon.play.classList.add('cp-play-icon-paused');
            } else {
                this.elementLinks.icon.play.classList.remove('cp-play-icon-paused');
            }
        }
    }, {
        key: "setProgress",
        value: function setProgress(point, currentTime, duration) {
            this.elementLinks.progressFill.style.width = point * 100 + "%";
            this.elementLinks.progressButton.style.right = (1 - point) * 100 + '%';
            this.elementLinks.progressCurrentTime.innerText = secondNumber2TimeStr(currentTime);
            this.elementLinks.progressDuration.innerText = secondNumber2TimeStr(duration);
        }
    }, {
        key: "setPoster",
        value: function setPoster(src) {
            this.elementLinks.poster.style.backgroundImage = "url(\"" + src + "\")";
        }
    }, {
        key: "setVolume",
        value: function setVolume(volume) {
            if (this.__OldVolume !== volume) {
                this.elementLinks.volumeFill.style.width = volume * 100 + "%";
                this.elementLinks.volumeControllerButton.style.right = (1 - volume) * 100 + '%';
                this.__OldVolume = volume;
            }
        }
    }, {
        key: "setMode",
        value: function setMode(mode) {
            var modeattr = document.createAttribute('data-mode');
            modeattr.value = mode;
            this.elementLinks.button.mode.attributes.setNamedItem(modeattr);
        }
    }, {
        key: "showInfo",
        value: function showInfo() {
            var dropDownMenu = this.elementLinks.dropDownMenu;
            dropDownMenu.style.height = '';
            dropDownMenu.classList.remove('cp-drop-down-menu-playlist');
            dropDownMenu.classList.add('cp-drop-down-menu-info');
            this.dropDownMenuShowInfo = true;
        }
    }, {
        key: "showPlaylist",
        value: function showPlaylist() {
            var dropDownMenu = this.elementLinks.dropDownMenu;
            dropDownMenu.style.height = this.player.playlist.length * 2.08333 + 'em';
            dropDownMenu.classList.remove('cp-drop-down-menu-info');
            dropDownMenu.classList.add('cp-drop-down-menu-playlist');
            this.dropDownMenuShowInfo = false;
        }
    }, {
        key: "toggleDropDownMenu",
        value: function toggleDropDownMenu() {
            if (this.dropDownMenuShowInfo) {
                this.showPlaylist();
            } else {
                this.showInfo();
            }
        }
    }, {
        key: "setVolumeControllerKeepShow",
        value: function setVolumeControllerKeepShow() {
            this.elementLinks.volumeControllerContainer.classList.add('cp-volume-container-show');
        }
    }, {
        key: "toggleVolumeControllerKeepShow",
        value: function toggleVolumeControllerKeepShow() {
            this.elementLinks.volumeControllerContainer.classList.toggle('cp-volume-container-show');
        }
    }, {
        key: "removeVolumeControllerKeepShow",
        value: function removeVolumeControllerKeepShow() {
            this.elementLinks.volumeControllerContainer.classList.remove('cp-volume-container-show');
        }
    }, {
        key: "setLyric",
        value: function setLyric(lyric) {
            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var totalTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            if (this.__OldLyric !== lyric || this.__OldTotalTime !== totalTime) {
                this.elementLinks.lyric.innerHTML = lyric;
                this.elementLinks.lyric.style.transition = '';
                this.elementLinks.lyric.style.transform = '';
                if (totalTime !== 0) {
                    var lyricWidth = this.elementLinks.lyric.clientWidth;
                    var lyricContainerWidth = this.elementLinks.lyricContainer.clientWidth;
                    if (lyricWidth > lyricContainerWidth) {
                        var duration = totalTime - time;
                        var targetOffset = lyricWidth - lyricContainerWidth;
                        var timepage = lyricContainerWidth / lyricWidth * duration;
                        var startTime = Math.min(timepage * 0.6, duration);
                        var moveTime = duration - timepage;
                        this.elementLinks.lyric.style.transition = "transform " + moveTime + "ms linear " + startTime + "ms";
                        this.elementLinks.lyric.style.transform = "translateX(-" + targetOffset + "px)";
                    }
                }
                this.__OldLyric = lyric;
                this.__OldTotalTime = totalTime;
            }
        }
    }, {
        key: "updatePlaylist",
        value: function updatePlaylist() {
            var _this2 = this;

            var lis = this.player.playlist.map(function (audio, index) {
                var element = document.createElement('li');
                element.innerHTML = "\n        " + (index === _this2.player.nowplaypoint ? playIcon : '<span class="cp-play-icon"></span>') + "\n        <span>" + audio.name + "</span><span class='cp-playlist-artist'>" + (audio.artist ? ' - ' + audio.artist : '') + "</span>\n      ";
                return element;
            });
            this.elementLinks.playlist.innerHTML = '';
            lis.forEach(function (li) {
                _this2.elementLinks.playlist.appendChild(li);
            });
            this.elementLinks.playlistItems = this.getPlayListLinks();
            this.injectPlayListEventListener();
            if (!this.dropDownMenuShowInfo) {
                this.elementLinks.dropDownMenu.style.height = this.player.playlist.length * 2.08333 + 'em';
            }
        }
    }, {
        key: "injectPlayListEventListener",
        value: function injectPlayListEventListener() {
            var _this3 = this;

            Array.prototype.forEach.call(this.elementLinks.playlistItems, function (i, index) {
                i.addEventListener('click', function (event) {
                    _this3.handleClickPlayList(index, event);
                });
            });
        }
    }, {
        key: "injectEventListener",
        value: function injectEventListener() {
            this.elementLinks.button.play.addEventListener('click', this.handleClickPlayButton);
            this.elementLinks.button.prev.addEventListener('click', this.handleClickPrevButton);
            this.elementLinks.button.next.addEventListener('click', this.handleClickNextButton);
            this.elementLinks.button.volume.addEventListener('click', this.handleClickVolumeButton);
            this.elementLinks.button.list.addEventListener('click', this.handleClickListButton);
            this.elementLinks.button.mode.addEventListener('click', this.handleClickModeButton);
            this.elementLinks.volumeController.addEventListener('mousemove', this.handleMouseVolumeController);
            this.elementLinks.volumeController.addEventListener('mousedown', this.handleMouseVolumeController);
            this.elementLinks.volumeController.addEventListener('touchmove', this.handleTouchVolumeController, { passive: true });
            this.elementLinks.progress.addEventListener('mousemove', this.handleMouseProgress);
            this.elementLinks.progress.addEventListener('mousedown', this.handleMouseProgress);
            this.elementLinks.progress.addEventListener('touchmove', this.handleTouchProgress, { passive: true });
            this.player.addListener('playstatechange', this.handlePlayStateChange);
            this.player.addListener('timeupdate', this.handleTimeUpdate);
            this.player.addListener('openaudio', this.handleOpenAudio);
            this.player.addListener('volumechange', this.handleVolumeChange);
            this.player.addListener('playmodechange', this.handleModeChange);
            this.player.addListener('playlistchange', this.handlePlaylistchange);
            this.player.addListener('audioelementchange', this.handleAudioElementChange);
            this.injectPlayListEventListener();
        }
    }, {
        key: "updateLyric",
        value: function updateLyric() {
            var playedTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (this.player.nowplay.lyric && typeof this.player.nowplay.lyric !== 'string' && this.player.played) {
                var lyric = this.player.nowplay.lyric.getLyric(playedTime * 1000);
                var nextLyric = this.player.nowplay.lyric.getNextLyric(playedTime * 1000);
                if (lyric) {
                    var sublyric = void 0;
                    if (this.player.nowplay.sublyric && typeof this.player.nowplay.sublyric !== 'string') {
                        sublyric = this.player.nowplay.sublyric.getLyric(playedTime * 1000);
                    }
                    if (nextLyric) {
                        var duration = nextLyric.time - lyric.time;
                        var currentTime = playedTime * 1000 - lyric.time;
                        this.setLyric(buildLyric(lyric.word, sublyric ? sublyric.word : undefined, this.options.zoomOutKana), currentTime, duration);
                    } else {
                        var _duration = this.player.duration - lyric.time;
                        var _currentTime = playedTime * 1000 - lyric.time;
                        this.setLyric(buildLyric(lyric.word, sublyric ? sublyric.word : undefined, this.options.zoomOutKana), _currentTime, _duration);
                    }
                } else {
                    this.setLyric(buildLyric(this.player.nowplay.name, this.player.nowplay.artist, false), playedTime * 1000, nextLyric.time);
                }
            } else {
                this.setLyric(buildLyric(this.player.nowplay.name, this.player.nowplay.artist, false));
            }
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this.rootElement.parentElement.removeChild(this.rootElement);
        }
    }]);

    return cplayerView;
}(events_1.EventEmitter);

exports.default = cplayerView;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
function returntypeof(expression) {
    return {};
}
exports.default = returntypeof;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = "<c-player loaded> <div class=cp-mainbody> <div class=cp-poster> </div> <div class=cp-center-container> <div class=cp-controls> <a class=cp-prev-button> <svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink class=cp-prev-icon viewBox=\"0 0 1024 1024\" version=1.1> <path d=\"M943.705 11.8c10.321 5.183 17.325 15.601 17.534 27.675l-0.004 938.318c-0.167 12.186-7.229 22.684-17.457 27.782-4.857 2.548-10.527 4.026-16.543 4.026a35.75 35.75 0 0 1-18.217-4.955l-716.617-469c-9.689-5.299-16.151-15.421-16.151-27.053 0-11.63 6.462-21.753 15.991-26.972L909.186 12.666c5.177-3.048 11.404-4.848 18.052-4.848a35.878 35.878 0 0 1 16.665 4.077z\"/> <path d=\"M228.435 77.809v868.712c-3.889 42.573-39.416 75.664-82.673 75.664s-78.784-33.091-82.649-75.34l-0.024-869.036C65.9 34.259 101.911 0 145.924 0s80.024 34.259 82.822 77.564z\"/> </svg> </a> <a class=cp-play-button> <span class=\"cp-play-icon cp-play-icon-paused\"> <div class=cp-play-icon-left></div> <div class=cp-play-icon-right></div> <div class=cp-play-icon-triangle-1></div> <div class=cp-play-icon-triangle-2></div> </span> </a> <a class=cp-next-button> <svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink class=cp-next-icon viewBox=\"0 0 1024 1024\" version=1.1> <path d=\"M943.705 11.8c10.321 5.183 17.325 15.601 17.534 27.675l-0.004 938.318c-0.167 12.186-7.229 22.684-17.457 27.782-4.857 2.548-10.527 4.026-16.543 4.026a35.75 35.75 0 0 1-18.217-4.955l-716.617-469c-9.689-5.299-16.151-15.421-16.151-27.053 0-11.63 6.462-21.753 15.991-26.972L909.186 12.666c5.177-3.048 11.404-4.848 18.052-4.848a35.878 35.878 0 0 1 16.665 4.077z\"/> <path d=\"M228.435 77.809v868.712c-3.889 42.573-39.416 75.664-82.673 75.664s-78.784-33.091-82.649-75.34l-0.024-869.036C65.9 34.259 101.911 0 145.924 0s80.024 34.259 82.822 77.564z\"/> </svg> </a> </div> <div class=cp-lyric> <span class=cp-lyric-text></span> </div> </div> <a class=cp-volume-button> <svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink class=\"cp-volume-icon cp-icon-dark\" viewBox=\"0 200 1024 650\" version=1.1> <path d=\"M607.869008 364.026176l-49.340512 49.340528c25.412064 25.160448 41.150352 60.055392 41.150352 98.637648 0 38.573568-15.738288 73.477184-41.150352 98.62896l49.340512 49.340512c37.836112-37.888176 61.244-90.195872 61.244-147.969488 0-57.782272-23.407888-110.081328-61.244-147.978176z\"/> <path d=\"M807.937968 512c0-96.086912-39.050752-183.055296-102.134064-245.904368L656.95792 314.9416c50.398992 50.45104 81.563248 120.1108 81.563248 197.0584 0 76.938912-31.172944 146.598672-81.563248 197.0584l48.845984 48.845968C768.887216 695.055296 807.937968 608.086896 807.937968 512z\"/> <path d=\"M946.780288 512.004336c0-134.434896-54.598176-256.107376-142.807248-344.082192l-49.088912 49.088896c75.65488 75.411952 122.470672 179.732384 122.470672 294.993296 0 115.252224-46.815792 219.581328-122.470672 294.984608l49.088912 49.088912c88.209072-87.966144 142.807248-209.647312 142.807248-344.07352z\"/> <path d=\"M247.605111 659.304938 458.566804 854.551527 458.566804 169.448479 251.58222 364.704275 53.490893 364.704275 53.490893 659.304938Z\"/> </svg> <div class=cp-volume-container> <div> <span class=cp-volume-controller> <span class=cp-volume-fill></span> <span class=cp-volume-controller-button></span> </span> </div> </div> </a> <a class=cp-list-button> <svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink class=\"cp-list-icon cp-icon-dark\" viewBox=\"0 0 1024 1024\" version=1.1> <path d=\"M168.57 820.6c0 14.34-9.56 23.89-23.89 23.89H96.89c-14.34 0-23.89-9.55-23.89-23.89v-47.79c0-14.34 9.56-23.89 23.89-23.89h47.79c14.34 0 23.89 9.56 23.89 23.89z m0-284.33c0 14.34-9.56 23.89-23.89 23.89H96.89c-14.34 0-23.89-9.56-23.89-23.89v-47.79c0-14.34 9.56-23.89 23.89-23.89h47.79c14.34 0 23.89 9.56 23.89 23.89z m0-286.72c0 14.34-9.56 23.89-23.89 23.89H96.89c-14.34 0-23.89-9.56-23.89-23.89v-47.79c0-14.34 9.56-23.89 23.89-23.89h47.79c14.34 0 23.89 9.56 23.89 23.89zM969 820.6c0 14.34-7.17 23.89-21.5 23.89H314.32c-14.34 0-23.89-9.56-23.89-23.89v-47.79c0-14.34 9.56-23.89 23.89-23.89H945.1c14.34 0 23.89 9.56 23.89 23.89z m0-284.33c0 14.34-7.17 23.89-21.5 23.89H314.32c-14.34 0-23.89-9.56-23.89-23.89v-47.79c0-14.34 9.56-23.89 23.89-23.89H945.1c14.34 0 23.89 9.56 23.89 23.89z m0-286.72c0 14.34-7.17 23.89-21.5 23.89H314.32c-14.34 0-23.89-9.56-23.89-23.89v-47.79c0-14.34 9.56-23.89 23.89-23.89H945.1c14.34 0 23.89 9.56 23.89 23.89z\"/> </svg> </a> <a class=cp-mode-button data-mode=listloop> <svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink class=\"cp-loop-icon cp-icon-dark\" viewBox=\"0 0 1024 1024\" version=1.1> <path d=\"M157 624c17.3-4.8 27.4-22.7 22.6-40-5.4-19.4-8.1-39.5-8.1-59.9 0-123.1 100.1-223.2 223.2-223.2h302.4v57.6c0 18.5 12.9 25.6 28.6 15.9l138.6-85.8c15.7-9.7 15.9-25.9 0.3-35.9l-139.2-89.9c-15.5-10-28.2-3.1-28.2 15.4V236H394.7c-77 0-149.3 30-203.8 84.4-54.4 54.4-84.4 126.8-84.4 203.8 0 26.2 3.5 52.2 10.5 77.3 4 14.4 17.1 23.8 31.3 23.8 2.9-0.1 5.8-0.4 8.7-1.3z m748.7-202.1c-4-14.4-17.1-23.8-31.3-23.8-2.9 0-5.8 0.4-8.7 1.2-17.3 4.8-27.4 22.7-22.6 40 5.4 19.4 8.1 39.5 8.1 59.9 0 123.1-100.1 223.2-223.2 223.2H325.5v-57.6c0-18.5-12.9-25.6-28.6-15.9l-138.6 85.8c-15.7 9.7-15.9 25.9-0.3 35.9l139.2 89.9c15.5 10 28.2 3.1 28.2-15.4v-57.9h302.4c77 0 149.3-30 203.8-84.4C886 648.4 916 576 916 499c0.1-26-3.4-52-10.3-77.1z\"/> </svg> <svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink class=\"cp-single-icon cp-icon-dark\" viewBox=\"0 0 1024 1024\" version=1.1> <path d=\"M102.5 653.9c17.3-4.8 27.4-22.7 22.6-40-5.4-19.4-8.1-43.4-8.1-63.8C117 427 217.1 323 340.2 323h132.3c1.4-20 5.4-40 11.7-60h-144c-77 0-149.4 31.4-203.8 85.8C82 403.2 52 476.3 52 553.3c0 26.2 3.5 52.6 10.5 77.6 4 14.4 17.1 24 31.3 24 2.9 0 5.8-0.2 8.7-1z m471 109.1H272v-68.3c0-18.5-13.3-25.6-29-15.9l-138.8 85.8c-15.7 9.7-16 25.9-0.5 35.9l139.7 89.9c15.5 10 28.7 3.1 28.7-15.4v-52h301.5c77 0 149.4-32.9 203.8-87.3 34.7-34.7 59.5-78.2 72.9-124-24 9-49.6 19.4-76.2 21.5-36.5 74-112.7 129.8-200.6 129.8zM752 127.9c-121.5 0-220 98.5-220 220s98.5 220 220 220 220-98.5 220-220-98.5-220-220-220zM792 463h-40V298.7c-20 14-36.2 24.5-60 31.3v-41.8c11.5-2.9 23.8-10.4 36.7-17.6 13-7.9 23.8-7.7 32.4-27.7H792V463z\"/> </svg> <svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink class=\"cp-random-icon cp-icon-dark\" viewBox=\"0 0 1024 1024\" version=1.1> <path d=\"M112 405.2h218.2c7.1 0 21 5.8 26 10.8l38 38.6c13.6 13.8 35.7 13.9 49.5 0.4 13.8-13.6 13.9-35.7 0.4-49.5l-38-38.6c-18.1-18.4-50-31.7-75.8-31.7H112c-19.3 0-35 15.7-35 35 0 19.4 15.7 35 35 35z m623.2 0h62.4v42.6c0 10.9 7.5 15 16.7 8.8l125.8-83.9c9.3-6.2 9.2-16.2 0-22.4l-125.8-83.9c-9.3-6.2-16.7-2.2-16.7 8.8v60h-62.4c-53.5 0-123.5 29.3-161 67.4L393.9 585.7c-24.3 24.7-76.4 46.5-111.1 46.5H112c-19.3 0-35 15.7-35 35s15.7 35 35 35h170.7c53.5 0 123.5-29.3 161-67.4L624 451.7c24.4-24.7 76.4-46.5 111.2-46.5z m79.1 161.2c-9.3-6.2-16.7-2.2-16.7 8.8v57H681.9c-6.9 0-20.2-5.6-25-10.4l-37.3-37.9c-13.6-13.8-35.7-13.9-49.5-0.4-13.8 13.6-13.9 35.7-0.4 49.5l37.3 37.9c18 18.2 49.3 31.3 74.9 31.3h115.6v45.6c0 10.9 7.5 15 16.7 8.8L940 672.7c9.3-6.2 9.2-16.2 0-22.4l-125.7-83.9z\"/> </svg> </a> <div class=cp-progress-container> <span class=cp-progress-current-time>07:24</span> <div class=cp-progress> <div class=cp-progress-fill></div> <span class=cp-progress-button></span> </div> <span class=cp-progress-duration>24:50</span> </div> </div> <div class=\"cp-drop-down-menu cp-drop-down-menu-info\"> <div class=cp-audio-info> <span class=cp-audio-title></span> - <span class=cp-audio-artist></span> </div> <ul class=cp-playlist> </ul> </div> </c-player>";

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = "<svg class=cp-play-icon viewBox=\"0 0 1024 1024\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink width=200 height=200> <path d=\"M64.279417 58.009844c0-21.327148 10.62092-39.540533 29.218194-50.118799a56.858178 56.858178 0 0 1 58.265769 0.255926l779.336659 453.969682c18.341348 10.706229 28.748996 28.748996 28.748996 49.905527 0 21.113877-10.407648 39.156645-28.748996 49.820219L151.76338 1015.854735a56.943486 56.943486 0 0 1-58.265769 0.255926 56.303672 56.303672 0 0 1-29.218194-50.161453V58.009844z\"> </path> </svg>";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(20)(undefined);
// imports


// module
exports.push([module.i, "@-webkit-keyframes miss-pointer-event {\n  0% {\n    pointer-events: none; }\n  50% {\n    pointer-events: none; }\n  100% {\n    pointer-events: auto; } }\n\n@keyframes miss-pointer-event {\n  0% {\n    pointer-events: none; }\n  50% {\n    pointer-events: none; }\n  100% {\n    pointer-events: auto; } }\n\nc-player {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: relative;\n  font-size: 12px;\n  width: 300px;\n  text-align: left; }\n  c-player .cp-mainbody {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    min-height: 4.16667em;\n    min-width: 25em;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    background-color: #fff;\n    position: relative;\n    z-index: 1;\n    border-radius: 0.33333em;\n    -webkit-box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;\n            box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px; }\n    c-player .cp-mainbody > * {\n      margin-right: 0.58333em; }\n    c-player .cp-mainbody:hover + .cp-drop-down-menu.cp-drop-down-menu-info {\n      height: 2.08333em; }\n  c-player .cp-drop-down-menu {\n    margin: 0em 0.16667em 0;\n    display: block;\n    text-align: center;\n    font-size: 1em;\n    line-height: 2.08333em;\n    background-color: rgba(255, 255, 255, 0.6);\n    position: relative;\n    z-index: 0;\n    height: 0em;\n    overflow: hidden;\n    border-bottom-right-radius: 0.33333em;\n    border-bottom-left-radius: 0.33333em;\n    -webkit-box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;\n            box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;\n    -webkit-transition: height 0.25s ease 0.1s, -webkit-transform 0.25s ease 0.1s;\n    transition: height 0.25s ease 0.1s, -webkit-transform 0.25s ease 0.1s;\n    transition: transform 0.25s ease 0.1s, height 0.25s ease 0.1s;\n    transition: transform 0.25s ease 0.1s, height 0.25s ease 0.1s, -webkit-transform 0.25s ease 0.1s; }\n    c-player .cp-drop-down-menu span.cp-audio-title {\n      max-width: 14.16667em;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n    c-player .cp-drop-down-menu span.cp-audio-artist {\n      opacity: 0.6;\n      max-width: 8.33333em;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n    c-player .cp-drop-down-menu.cp-drop-down-menu-top {\n      -webkit-box-ordinal-group: 0;\n          -ms-flex-order: -1;\n              order: -1; }\n    c-player .cp-drop-down-menu.cp-drop-down-menu-none {\n      display: none; }\n    c-player .cp-drop-down-menu.cp-drop-down-menu-bottom {\n      -webkit-box-ordinal-group: 2;\n          -ms-flex-order: 1;\n              order: 1; }\n    c-player .cp-drop-down-menu.cp-drop-down-menu-info .cp-playlist {\n      display: none; }\n    c-player .cp-drop-down-menu.cp-drop-down-menu-info:hover {\n      height: 2.08333em; }\n    c-player .cp-drop-down-menu.cp-drop-down-menu-playlist .cp-audio-info {\n      display: none; }\n    c-player .cp-drop-down-menu.cp-drop-down-menu-playlist {\n      height: auto; }\n  c-player .cp-playlist {\n    margin: 0em;\n    padding: 0em;\n    list-style: none;\n    text-align: left; }\n    c-player .cp-playlist li {\n      padding: 0em 0.83333em;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      cursor: pointer; }\n      c-player .cp-playlist li .cp-play-icon {\n        display: inline-block;\n        width: 1em;\n        height: 1em;\n        vertical-align: text-top;\n        margin: 0px 0.41667em 0 0;\n        fill: rgba(183, 28, 28, 0.8); }\n  c-player .cp-playlist-artist {\n    opacity: 0.46; }\n  c-player .cp-center-container {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    position: relative;\n    height: 4.16667em;\n    pointer-events: auto; }\n    c-player .cp-center-container .cp-controls {\n      opacity: 0; }\n    c-player .cp-center-container:hover .cp-controls {\n      opacity: 1;\n      -webkit-animation: miss-pointer-event 100ms;\n              animation: miss-pointer-event 100ms;\n      -webkit-animation-fill-mode: both;\n              animation-fill-mode: both; }\n    c-player .cp-center-container:hover .cp-lyric {\n      opacity: 0; }\n  c-player .cp-controls {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    -webkit-transition: opacity 0.25s ease;\n    transition: opacity 0.25s ease; }\n    c-player .cp-controls > * {\n      margin-right: 1.25em;\n      -webkit-tap-highlight-color: transparent; }\n  c-player .cp-lyric {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    position: absolute;\n    width: calc(100% - 1.66667em);\n    height: calc(100% - 0.83333em);\n    overflow: hidden;\n    margin: 0.41667em 0.83333em;\n    font-size: 1.16667em;\n    -webkit-transition: opacity 0.25s ease;\n    transition: opacity 0.25s ease; }\n  c-player .cp-lyric-text {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    white-space: nowrap;\n    text-align: center;\n    color: #424242; }\n    c-player .cp-lyric-text .cp-lyric-text-sub {\n      display: block;\n      color: #757575;\n      font-size: 0.85714em; }\n    c-player .cp-lyric-text .cp-lyric-text-zoomout {\n      font-size: 1em;\n      -webkit-transform: translateY(0.08333em);\n              transform: translateY(0.08333em);\n      display: inline-block;\n      margin: 0px 0.14286em; }\n  c-player .cp-progress-container {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    margin: 0em;\n    opacity: 0.8;\n    position: absolute;\n    width: 100%;\n    bottom: 0px;\n    border-bottom-left-radius: 0.33333em;\n    border-bottom-right-radius: 0.33333em;\n    overflow: hidden;\n    pointer-events: none; }\n    c-player .cp-progress-container > span {\n      display: none; }\n  c-player.cp-big .cp-progress-container {\n    position: relative;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    height: 2.91667em;\n    padding: 0 0.41667em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    pointer-events: auto;\n    color: #424242; }\n    c-player.cp-big .cp-progress-container > span {\n      display: inline;\n      margin: 0 1.25em;\n      font-size: 0.8em; }\n  c-player .cp-progress {\n    overflow: hidden; }\n    c-player .cp-progress .cp-progress-fill {\n      display: block;\n      height: 0.16667em;\n      background: #F44336; }\n    c-player .cp-progress .cp-progress-button {\n      display: none; }\n  c-player.cp-big .cp-progress {\n    overflow: visible; }\n  c-player .cp-poster {\n    width: 4.16667em;\n    height: 4.16667em;\n    background-repeat: repeat;\n    background-position: 50% 50%;\n    background-size: cover;\n    background-color: #fafafa;\n    background-origin: padding-box;\n    background-attachment: scroll;\n    border-right: 0.08333em solid #eee;\n    background-image: url(" + __webpack_require__(1) + ");\n    border-top-left-radius: 0.33333em;\n    border-bottom-left-radius: 0.33333em;\n    overflow: hidden; }\n    c-player .cp-poster video {\n      width: 100%;\n      height: 100%; }\n  c-player.cp-big .cp-poster {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    width: 25em;\n    height: 14.0625em;\n    border-right: none;\n    border-bottom: 0.08333em solid #eee;\n    margin: 0;\n    border-top-left-radius: 0.33333em;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: 0.33333em;\n    border-bottom-right-radius: 0; }\n  c-player .cp-play-icon {\n    width: 1.04167em;\n    height: 1.04167em;\n    display: block;\n    overflow: hidden;\n    position: relative; }\n    c-player .cp-play-icon .cp-play-icon-left {\n      height: 100%;\n      float: left;\n      background-color: #F44336;\n      width: 36%;\n      -webkit-transition: width 0.25s ease;\n      transition: width 0.25s ease;\n      overflow: hidden; }\n    c-player .cp-play-icon .cp-play-icon-right {\n      height: 100%;\n      float: right;\n      background-color: #F44336;\n      width: 36%;\n      -webkit-transition: width 0.25s ease;\n      transition: width 0.25s ease;\n      overflow: hidden; }\n    c-player .cp-play-icon .cp-play-icon-triangle-1 {\n      -webkit-transform: translate(0, -100%);\n              transform: translate(0, -100%); }\n    c-player .cp-play-icon .cp-play-icon-triangle-2 {\n      -webkit-transform: translate(0, 100%);\n              transform: translate(0, 100%); }\n    c-player .cp-play-icon .cp-play-icon-triangle-1,\n    c-player .cp-play-icon .cp-play-icon-triangle-2 {\n      position: absolute;\n      top: 0;\n      right: 0;\n      background-color: transparent;\n      width: 0;\n      height: 0;\n      border-right: 1.04167em solid #fff;\n      border-top: 0.52083em solid transparent;\n      border-bottom: 0.52083em solid transparent;\n      -webkit-transition: -webkit-transform 0.25s ease;\n      transition: -webkit-transform 0.25s ease;\n      transition: transform 0.25s ease;\n      transition: transform 0.25s ease, -webkit-transform 0.25s ease; }\n    c-player .cp-play-icon.cp-play-icon-paused .cp-play-icon-left {\n      width: 50%; }\n    c-player .cp-play-icon.cp-play-icon-paused .cp-play-icon-right {\n      width: 50%; }\n    c-player .cp-play-icon.cp-play-icon-paused .cp-play-icon-triangle-1 {\n      -webkit-transform: translate(0, -50%);\n              transform: translate(0, -50%); }\n    c-player .cp-play-icon.cp-play-icon-paused .cp-play-icon-triangle-2 {\n      -webkit-transform: translate(0, 50%);\n              transform: translate(0, 50%); }\n    c-player .cp-play-icon.cp-play-icon-hover .cp-play-icon-left, c-player .cp-play-button:hover .cp-play-icon-left {\n      background-color: #B71C1C; }\n    c-player .cp-play-icon.cp-play-icon-hover .cp-play-icon-right, c-player .cp-play-button:hover .cp-play-icon-right {\n      background-color: #B71C1C; }\n  c-player .cp-play-button,\n  c-player .cp-volume-button,\n  c-player .cp-prev-button,\n  c-player .cp-list-button,\n  c-player .cp-mode-button,\n  c-player .cp-next-button {\n    display: inline-block;\n    width: 1.04167em;\n    height: 1.04167em;\n    cursor: pointer; }\n  c-player .cp-volume-button {\n    width: 1.66667em;\n    position: relative; }\n  c-player .cp-list-button {\n    width: 1.45833em;\n    height: 1.45833em; }\n  c-player .cp-mode-button {\n    width: 1.58333em;\n    height: 1.58333em; }\n  c-player .cp-play-button {\n    height: 2.5em;\n    width: 2.5em;\n    border: #F44336 solid 1px;\n    border-radius: 50%; }\n    c-player .cp-play-button .cp-play-icon.cp-play-icon-paused {\n      margin: 0.6875em; }\n    c-player .cp-play-button .cp-play-icon {\n      margin: 0.6875em; }\n    c-player .cp-play-button:hover {\n      border-color: #B71C1C; }\n  c-player .cp-icon, c-player .cp-prev-icon, c-player .cp-next-icon, c-player .cp-volume-icon, c-player .cp-random-icon, c-player .cp-single-icon, c-player .cp-loop-icon, c-player .cp-list-icon {\n    height: 1.04167em;\n    width: 1.04167em; }\n    c-player .cp-icon path, c-player .cp-prev-icon path, c-player .cp-next-icon path, c-player .cp-volume-icon path, c-player .cp-random-icon path, c-player .cp-single-icon path, c-player .cp-loop-icon path, c-player .cp-list-icon path {\n      fill: #F44336; }\n    c-player .cp-icon:hover path, c-player .cp-prev-icon:hover path, c-player .cp-next-icon:hover path, c-player .cp-volume-icon:hover path, c-player .cp-random-icon:hover path, c-player .cp-single-icon:hover path, c-player .cp-loop-icon:hover path, c-player .cp-list-icon:hover path {\n      fill: #B71C1C; }\n    c-player .cp-icon.cp-icon-dark path, c-player .cp-icon-dark.cp-prev-icon path, c-player .cp-icon-dark.cp-next-icon path, c-player .cp-icon-dark.cp-volume-icon path, c-player .cp-icon-dark.cp-random-icon path, c-player .cp-icon-dark.cp-single-icon path, c-player .cp-icon-dark.cp-loop-icon path, c-player .cp-icon-dark.cp-list-icon path {\n      fill: #757575; }\n    c-player .cp-icon.cp-icon-dark:hover path, c-player .cp-icon-dark.cp-prev-icon:hover path, c-player .cp-icon-dark.cp-next-icon:hover path, c-player .cp-icon-dark.cp-volume-icon:hover path, c-player .cp-icon-dark.cp-random-icon:hover path, c-player .cp-icon-dark.cp-single-icon:hover path, c-player .cp-icon-dark.cp-loop-icon:hover path, c-player .cp-icon-dark.cp-list-icon:hover path {\n      fill: #616161; }\n  c-player .cp-next-icon {\n    -webkit-transform: rotateZ(180deg);\n            transform: rotateZ(180deg); }\n  c-player .cp-volume-icon {\n    width: 1.66667em; }\n  c-player .cp-random-icon,\n  c-player .cp-single-icon,\n  c-player .cp-loop-icon {\n    width: 1.58333em;\n    height: 1.58333em;\n    display: none; }\n  c-player .cp-mode-button[data-mode=listloop] .cp-loop-icon,\n  c-player .cp-mode-button[data-mode=singlecycle] .cp-single-icon,\n  c-player .cp-mode-button[data-mode=listrandom] .cp-random-icon {\n    display: block; }\n  c-player .cp-list-icon {\n    width: 1.45833em;\n    height: 1.45833em; }\n  c-player .cp-volume-container {\n    position: absolute;\n    left: 50%;\n    top: -7px;\n    height: 2.08333em;\n    width: 10.83333em;\n    -webkit-transform: translateX(-50%) translateY(-120%);\n            transform: translateX(-50%) translateY(-120%);\n    z-index: 1;\n    visibility: hidden;\n    text-align: left;\n    border-radius: 0.33333em;\n    padding: 0 15px;\n    background: #fff;\n    -webkit-box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;\n            box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px; }\n    c-player .cp-volume-container.cp-volume-container-show {\n      visibility: visible; }\n    c-player .cp-volume-container:hover {\n      visibility: visible; }\n    c-player .cp-volume-container:before {\n      content: '';\n      width: 0em;\n      height: 0em;\n      display: inline-block;\n      border-top: 0.83333em solid #fff;\n      border-left: 0.83333em solid transparent;\n      border-right: 0.83333em solid transparent;\n      position: absolute;\n      bottom: 0em;\n      left: 50%;\n      -webkit-transform: translate(-50%, 100%);\n              transform: translate(-50%, 100%); }\n    c-player .cp-volume-container:after {\n      content: '';\n      width: 1.17851em;\n      height: 1.17851em;\n      display: inline-block;\n      position: absolute;\n      bottom: 0em;\n      left: 50%;\n      -webkit-transform: translate(-50%, 50%) rotate(45deg);\n              transform: translate(-50%, 50%) rotate(45deg);\n      -webkit-box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;\n              box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px; }\n    c-player .cp-volume-container > div {\n      width: 100%;\n      height: 100%;\n      background: #fff;\n      border-radius: 0.33333em;\n      position: relative;\n      z-index: 1;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center; }\n  c-player.cp-big .cp-progress, c-player .cp-volume-controller, c-player.cp-dark.cp-big .cp-progress {\n    display: inline-block;\n    height: 0.33333em;\n    width: 100%;\n    border-radius: 0.16667em;\n    background: #BDBDBD;\n    line-height: 0;\n    -ms-touch-action: none;\n        touch-action: none;\n    position: relative; }\n    c-player.cp-big .cp-progress .cp-progress-fill, c-player .cp-volume-controller .cp-volume-fill, c-player.cp-dark.cp-big .cp-progress .cp-volume-controller .cp-volume-fill, c-player.cp-dark.cp-big .cp-volume-controller .cp-progress .cp-volume-fill, c-player.cp-dark.cp-big .cp-progress .cp-progress-fill {\n      display: inline-block;\n      height: 100%;\n      width: 100%;\n      border-radius: 0.16667em;\n      background: #616161; }\n    c-player.cp-big .cp-progress .cp-progress-button, c-player .cp-volume-controller .cp-volume-controller-button, c-player.cp-dark.cp-big .cp-progress .cp-volume-controller .cp-volume-controller-button, c-player.cp-dark.cp-big .cp-volume-controller .cp-progress .cp-volume-controller-button, c-player.cp-dark.cp-big .cp-progress .cp-progress-button {\n      height: 1.25em;\n      width: 1.25em;\n      position: absolute;\n      right: 0em;\n      top: -0.45833em;\n      display: inline-block;\n      border-radius: 50%;\n      border: 0.16667em solid #fff;\n      background: #757575;\n      -webkit-transform: translateX(50%);\n              transform: translateX(50%); }\n      c-player.cp-big .cp-progress .cp-progress-button:hover, c-player .cp-volume-controller .cp-volume-controller-button:hover {\n        background: #616161; }\n  c-player svg {\n    vertical-align: top; }\n  c-player *,\n  c-player *::before,\n  c-player *::after {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box; }\n\nc-player.cp-dark {\n  color: #bbb; }\n  c-player.cp-dark .cp-mainbody {\n    background-color: #222; }\n  c-player.cp-dark .cp-drop-down-menu {\n    background-color: rgba(34, 34, 34, 0.9); }\n  c-player.cp-dark .cp-playlist li .cp-play-icon {\n    fill: rgba(189, 189, 189, 0.8); }\n  c-player.cp-dark .cp-lyric-text {\n    color: #bbb; }\n    c-player.cp-dark .cp-lyric-text .cp-lyric-text-sub {\n      color: #757575; }\n  c-player.cp-dark .cp-progress .cp-progress-fill {\n    background: #BDBDBD; }\n  c-player.cp-dark .cp-poster {\n    background-color: #333;\n    border-right-color: #333; }\n  c-player.cp-dark.cp-big .cp-poster {\n    border-bottom-color: #333; }\n  c-player.cp-dark.cp-big .cp-progress-container {\n    color: #bbb; }\n  c-player.cp-dark.cp-big .cp-progress {\n    overflow: visible; }\n  c-player.cp-dark .cp-play-icon .cp-play-icon-left {\n    background-color: #a1a1a1; }\n  c-player.cp-dark .cp-play-icon .cp-play-icon-right {\n    background-color: #a1a1a1; }\n  c-player.cp-dark .cp-play-icon .cp-play-icon-triangle-1,\n  c-player.cp-dark .cp-play-icon .cp-play-icon-triangle-2 {\n    border-right-color: #222; }\n  c-player.cp-dark .cp-play-icon.cp-play-icon-hover .cp-play-icon-left, c-player.cp-dark .cp-play-button:hover .cp-play-icon-left {\n    background-color: #BDBDBD; }\n  c-player.cp-dark .cp-play-icon.cp-play-icon-hover .cp-play-icon-right, c-player.cp-dark .cp-play-button:hover .cp-play-icon-right {\n    background-color: #BDBDBD; }\n  c-player.cp-dark .cp-play-button {\n    border-color: #a1a1a1; }\n    c-player.cp-dark .cp-play-button:hover {\n      border-color: #BDBDBD; }\n  c-player.cp-dark .cp-icon path, c-player.cp-dark .cp-prev-icon path, c-player.cp-dark .cp-next-icon path, c-player.cp-dark .cp-volume-icon path, c-player.cp-dark .cp-random-icon path, c-player.cp-dark .cp-single-icon path, c-player.cp-dark .cp-loop-icon path, c-player.cp-dark .cp-list-icon path {\n    fill: #a1a1a1; }\n  c-player.cp-dark .cp-icon:hover path, c-player.cp-dark .cp-prev-icon:hover path, c-player.cp-dark .cp-next-icon:hover path, c-player.cp-dark .cp-volume-icon:hover path, c-player.cp-dark .cp-random-icon:hover path, c-player.cp-dark .cp-single-icon:hover path, c-player.cp-dark .cp-loop-icon:hover path, c-player.cp-dark .cp-list-icon:hover path {\n    fill: #BDBDBD; }\n  c-player.cp-dark .cp-icon.cp-icon-dark path, c-player.cp-dark .cp-icon-dark.cp-prev-icon path, c-player.cp-dark .cp-icon-dark.cp-next-icon path, c-player.cp-dark .cp-icon-dark.cp-volume-icon path, c-player.cp-dark .cp-icon-dark.cp-random-icon path, c-player.cp-dark .cp-icon-dark.cp-single-icon path, c-player.cp-dark .cp-icon-dark.cp-loop-icon path, c-player.cp-dark .cp-icon-dark.cp-list-icon path {\n    fill: #757575; }\n  c-player.cp-dark .cp-icon.cp-icon-dark:hover path, c-player.cp-dark .cp-icon-dark.cp-prev-icon:hover path, c-player.cp-dark .cp-icon-dark.cp-next-icon:hover path, c-player.cp-dark .cp-icon-dark.cp-volume-icon:hover path, c-player.cp-dark .cp-icon-dark.cp-random-icon:hover path, c-player.cp-dark .cp-icon-dark.cp-single-icon:hover path, c-player.cp-dark .cp-icon-dark.cp-loop-icon:hover path, c-player.cp-dark .cp-icon-dark.cp-list-icon:hover path {\n    fill: #616161; }\n  c-player.cp-dark .cp-volume-container {\n    background: #222; }\n    c-player.cp-dark .cp-volume-container:before {\n      border-top-color: #222; }\n    c-player.cp-dark .cp-volume-container > div {\n      background: #222; }\n  c-player.cp-dark c-player.cp-big .cp-progress, c-player.cp-big c-player.cp-dark .cp-progress, c-player.cp-dark .cp-volume-controller, c-player.cp-dark.cp-big .cp-progress {\n    background: #616161; }\n    c-player.cp-dark c-player.cp-big .cp-progress .cp-progress-fill, c-player.cp-big c-player.cp-dark .cp-progress .cp-progress-fill, c-player.cp-big .cp-progress c-player.cp-dark .cp-volume-controller .cp-progress-fill, c-player.cp-dark .cp-volume-controller .cp-volume-fill, c-player.cp-dark.cp-big .cp-progress .cp-progress-fill {\n      background: #BDBDBD; }\n    c-player.cp-dark c-player.cp-big .cp-progress .cp-progress-button, c-player.cp-big c-player.cp-dark .cp-progress .cp-progress-button, c-player.cp-big .cp-progress c-player.cp-dark .cp-volume-controller .cp-progress-button, c-player.cp-dark .cp-volume-controller .cp-volume-controller-button, c-player.cp-dark.cp-big .cp-progress .cp-progress-button {\n      border-color: #222;\n      background: #757575; }\n      c-player.cp-dark c-player.cp-big .cp-progress .cp-progress-button:hover, c-player.cp-big c-player.cp-dark .cp-progress .cp-progress-button:hover, c-player.cp-big .cp-progress c-player.cp-dark .cp-volume-controller .cp-progress-button:hover, c-player.cp-dark .cp-volume-controller .cp-volume-controller-button:hover, c-player.cp-dark.cp-big .cp-progress .cp-progress-button:hover {\n        background: #BDBDBD; }\n", ""]);

// exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// cplayer.js